"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var idlUtils = require("../generated/utils.js");
var _require = require("../attributes"),
  setAttributeValue = _require.setAttributeValue,
  removeAttributeByName = _require.removeAttributeByName;
var validateName = require("../helpers/validate-names").name;
var DOMException = require("domexception/webidl2js-wrapper");
var dataAttrRe = /^data-([^A-Z]*)$/;
function attrCamelCase(name) {
  return name.replace(/-([a-z])/g, function (match, alpha) {
    return alpha.toUpperCase();
  });
}
function attrSnakeCase(name) {
  return name.replace(/[A-Z]/g, function (match) {
    return "-".concat(match.toLowerCase());
  });
}
exports.implementation = /*#__PURE__*/function (_idlUtils$supportedPr, _idlUtils$namedGet, _idlUtils$namedSetNew, _idlUtils$namedSetExi, _idlUtils$namedDelete) {
  function DOMStringMapImpl(globalObject, args, privateData) {
    _classCallCheck(this, DOMStringMapImpl);
    this._globalObject = globalObject;
    this._element = privateData.element;
  }
  _createClass(DOMStringMapImpl, [{
    key: _idlUtils$supportedPr,
    get: function get() {
      var result = new Set();
      var attributes = this._element.attributes;
      for (var i = 0; i < attributes.length; i++) {
        var attr = attributes.item(i);
        var matches = dataAttrRe.exec(attr.localName);
        if (matches) {
          result.add(attrCamelCase(matches[1]));
        }
      }
      return result;
    }
  }, {
    key: _idlUtils$namedGet,
    value: function value(name) {
      var attributes = this._element.attributes;
      for (var i = 0; i < attributes.length; i++) {
        var attr = attributes.item(i);
        var matches = dataAttrRe.exec(attr.localName);
        if (matches && attrCamelCase(matches[1]) === name) {
          return attr.value;
        }
      }
      return undefined;
    }
  }, {
    key: _idlUtils$namedSetNew,
    value: function value(name, _value) {
      if (/-[a-z]/.test(name)) {
        throw DOMException.create(this._globalObject, ["'".concat(name, "' is not a valid property name"), "SyntaxError"]);
      }
      name = "data-".concat(attrSnakeCase(name));
      validateName(this._globalObject, name);
      setAttributeValue(this._element, name, _value);
    }
  }, {
    key: _idlUtils$namedSetExi,
    value: function value(name, _value2) {
      this[idlUtils.namedSetNew](name, _value2);
    }
  }, {
    key: _idlUtils$namedDelete,
    value: function value(name) {
      name = "data-".concat(attrSnakeCase(name));
      removeAttributeByName(this._element, name);
    }
  }]);
  return DOMStringMapImpl;
}(idlUtils.supportedPropertyNames, idlUtils.namedGet, idlUtils.namedSetNew, idlUtils.namedSetExisting, idlUtils.namedDelete);